module.exports = __webpack_public_path__ + "static/3.1-5f1ce869938b7d5c5648d0316f332c91.png";